import { InputGroupDesignTokens } from '@primeuix/themes/aura/inputgroup';

export const inputGroupTokens: InputGroupDesignTokens = {
  addon: {
    background: '{form.field.background}',
    borderColor: '{form.field.border.color}',
    borderRadius: '{form.field.border.radius}',
    color: '{form.field.icon.color}',
    padding: '0.5rem',
    minWidth: '2.5rem',
  },
};
